<!-- 设备详情 -->
<template>
    <div>
        <div id="map1" style="width: 100%;height: 400px;border:1px solid red"></div>
        <div>sdszzzxcccc11111111</div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            name: 'xxx'
        }
    },
    mounted() {
        console.log("xxxxxxxxxx")
        this.initMap11()
    },

    methods: {
        initMap11() {

            console.log("init...map")

            new ol.Map({
                target: 'map1',
                layers: [
                    new TileLayer(
                        {
                            source: new XYZ({
                                url: "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineCommunity/MapServer/tile/{z}/{y}/{x}",
                            }),
                        },
                        { zoomOffset: 1 }
                    ),
                ],
                view: new ol.View({
                    center: ol.proj.fromLonLat([37.41, 8.82]),
                    zoom: 4
                })
            });
        }
    }
}
</script>

